import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';

function TestTranslationMenu({ classes, handleSelectLanguage }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const testLangItems = ['en', 'es', 'pt', 'ru', 'ko', 'de'];
  return (
    <>
      <Button color="secondary" variant="contained" size="small" className={classes.testLangBtn} onClick={handleClick}>
        QA Languages
      </Button>
      <Menu
        anchorEl={anchorEl}
        classes={{ paper: classes.paper, list: classes.testLangList }}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {testLangItems.map((item, index) => (
          <MenuItem
            key={`testLang_${index + 1}`}
            onClick={() => {
              handleClose();
              handleSelectLanguage(item);
            }}
          >
            {item}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

TestTranslationMenu.propTypes = {
  classes: PropTypes.object,
  handleSelectLanguage: PropTypes.func,
};

export default TestTranslationMenu;
